import { cn } from '../../lib/cn';
import type { BetaOpsRow } from '../../enterprisebeta/framework';

type Props = { items?: BetaOpsRow[] };

export function BetaOperationsPanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((i) => (
        <div key={i.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{i.category}</p>
          <p className="text-sm font-medium">{i.name}</p>
          <div className="mt-1 flex items-center justify-between">
            <p className="text-lg font-semibold">{i.value}</p>
            <span className={cn(
              'text-xs font-medium',
              i.status === 'within_sla' || i.status === 'healthy' || i.status === 'strong' || i.status === 'addressed'
                ? 'text-success-600' : 'text-brand-600',
            )}>
              {i.status.replace('_', ' ')}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
